var _ = require('underscore');
module.exports = function(options){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
__p+='';
 // BE CAUTIOUS: this file is a fork of 'qv-sec-property-header.jst' 
__p+='\n\n';
 let { property, lotunitslabel, is_mobile, isSaveable, listingId, isLoggedIn, resId, ab_promo, isSpecHome } = options; 
__p+='\n\n';
 if (ab_promo) { 
__p+='\n  '+
((__t=( JST["quick_view/templates/optimization/enhanced-label"]({ is_mobile }) ))==null?'':__t)+
'\n';
 } 
__p+='\n\n<div class="ab-v2 qv-property-header">\n  ';
 if (isSaveable !== undefined && listingId && !isSpecHome) { 
__p+='\n    <a href="javascript:void(0)" data-omtag="ldp:quickview:sticky:save:top:save" class="js-hide-ajax-fail qv-favorite qv-photo-save ';
 if (isLoggedIn) { 
__p+='qv-';
 if (isSaveable) { 
__p+='un';
 } 
__p+='save';
 } else { 
__p+='qv-save-not-logged-in';
 } 
__p+='" data-listingid="'+
((__t=( listingId ))==null?'':__t)+
'" ';
 if (isSaveable) { 
__p+='data-res-id="'+
((__t=( resId ))==null?'':__t)+
'"';
 } 
__p+='>\n      <i class="ra ra-heart';
 if (!isSaveable) { 
__p+='-o';
 } 
__p+='"></i>\n    </a>\n  ';
 } 
__p+='\n  ';
 if(!is_mobile) { 
__p+='\n    <div class="clearfix ad-quick-view-wrapper">\n      <div id="div-gpt-ad-TXTLDP1" class="ad-quick-view-preload pull-left TXTLDPLoading"></div>\n    </div>\n  ';
 } 
__p+='\n  <div class="row main-info">\n    <div class="col-qv-xs-12 col-qv-sm-8 col-qv-md-12">\n      <div class="clearfix">\n        ';
 if(property.price_display) { 
__p+='\n            <div itemprop="offers" itemscope itemtype="http://schema.org/Offer" itemid="#offer" class="price">\n                <span itemprop="price" content="'+
((__t=( property.price ))==null?'':__t)+
'">\n                  ';
 if(property.price_display){ 
__p+='\n                    ';
 if(property.property_type == "new_plan") { 
__p+=' <span class="font-size-base font-normal">from</span> ';
 } 
__p+='\n                    '+
((__t=( property.price_display ))==null?'':__t)+
'\n                    ';
 if(property.flags && property.flags.is_price_reduced && !MOVE_DATA.ab_hlt_price_drop === "V1") { 
__p+=' <i class="ra ra-arrow-down icon-reduce-price color-green"></i> ';
 } 
__p+='\n                  ';
 } 
__p+='\n                </span>\n                <meta itemprop="priceCurrency" content="USD">\n                <link itemprop="businessFunction" href="http://purl.org/goodrelations/v1#Sell">\n                <meta itemprop="category" content="Real Estate > '+
((__t=( property.status_display ))==null?'':__t)+
'">\n            </div>\n            <a id="estimate-payment-link" class="estimate-payment-link js-hide-ajax-fail" open-payment-modal href="#" data-omtag="ldp:propInfo:estimatePayment">\n              <i class="ra ra-calculator font-size-base ldp-mortgage-toggle-icon"></i>\n              Estimate Payment\n            </a>\n          ';
 } 
__p+='\n      </div>\n      <div class="clearfix key-info">\n        <h2 class="address">\n          ';
 let addressUnavailable = property.address_display === 'Address Not Available' || (property.flags && property.flags.is_address_suppressed),
                 noAddressMeta      = !property.city && !property.state_code && !property.postal_code; 
__p+='\n          ';
 if (addressUnavailable && noAddressMeta) { 
__p+='\n            Address Not Available\n          ';
 } else if (property.address) { 
__p+='\n            '+
((__t=( property.address ))==null?'':__t)+
',\n            <span>\n              '+
((__t=( property.city ))==null?'':__t)+
',\n              '+
((__t=( property.state_code ))==null?'':__t)+
'\n              '+
((__t=( property.postal_code ))==null?'':__t)+
'\n            </span>\n          ';
 } else { 
__p+='\n            '+
((__t=( property.full_address_display ))==null?'':__t)+
'\n          ';
 } 
__p+='\n        </h2>\n      </div>\n      <div class="clearfix meta-info">\n        <ul class="property-meta list-horizontal list-unstyled">\n          ';
 if(property.beds) { 
__p+='\n            <li>\n              <span class="font-bold">'+
((__t=( property.beds ))==null?'':__t)+
'</span>\n                bed\n            </li>\n          ';
 } 
__p+='\n          ';
 if(property.baths) { 
__p+='\n            <li class="';
 if(property.baths_full && property.baths_half) { 
__p+=' display-half-bath ';
 } 
__p+='">\n              ';
 if(property.baths_full && property.baths_half) { 
__p+='\n                <span class="font-bold">'+
((__t=( property.baths_full ))==null?'':__t)+
'</span> full,\n                <span class="font-bold">'+
((__t=( property.baths_half ))==null?'':__t)+
'</span> half bath\n              ';
 } else { 
__p+='\n                  <span class="font-bold">'+
((__t=( property.baths ))==null?'':__t)+
'</span>\n                    bath\n              ';
 } 
__p+='\n            </li>\n          ';
 } 
__p+='\n          ';
 if(property.sqft_display) { 
__p+='\n            <li>\n                <span class="font-bold">'+
((__t=( property.sqft_display ))==null?'':__t)+
'</span> sqft\n            </li>\n          ';
 } 
__p+='\n          ';
 if(property.lot_size_display) { 
__p+='\n            <li>\n                <span class="font-bold">'+
((__t=( property.lot_size_display ))==null?'':__t)+
'</span>  '+
((__t=( lotunitslabel ))==null?'':__t)+
'\n            </li>\n          ';
 } 
__p+='\n        </ul>\n      </div>\n    </div>\n\n    <div class="col-qv-sm-4 hidden-qv-md hidden-qv-lg">\n      <div class="js-hide-ajax-fail pos-relative qv-fullmap-btn-wrapper loading qv-map-btn-v2">\n        <a href="" class="display-block map-btn fullmap-view" data-omtag="ldp:quickview:map:snapshot">\n          <img src="'+
((__t=( property.mapUrl ? property.mapUrl : '' ))==null?'':__t)+
'" class="hide">\n        </a>\n        <a href="" class="street-view-btn hide fullmap-street-view" title="Street View"  data-omtag="ldp:quickview:streetview:snapshot"></a>\n      </div>\n    </div>\n\n  </div>\n</div>\n\n';
 if(is_mobile) { 
__p+='\n  <div class="clearfix visible-qv-xs-block">\n     <div id="div-gpt-ad-TXTLDP1" class="ad-quick-view-preload ad-quick-view-mobile-top TXTLDPLoading"></div>\n  </div>\n';
 } 
__p+='\n';
return __p;
};



// WEBPACK FOOTER //
// ./quick_view/templates/qv-sec-property-header-ab.jst.ejs